import React from 'react';
import Select, { Props as SelectProps, GroupBase } from 'react-select';
import { useTheme } from '@chakra-ui/react';

export type ReactSelectWithChakraStyleProps<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
> = SelectProps<Option, IsMulti, Group>;

export const ReactSelectWithChakraStyle = <
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: ReactSelectWithChakraStyleProps<Option, IsMulti, Group>) => {
  const theme = useTheme();
  const customStyles = {
    control: (provided:any) => ({
      ...provided,
      borderRadius: theme.radii.md,
      borderColor: theme.colors.gray[200],
      '&:hover': {
        borderColor: theme.colors.gray[300],
      },
    }),
    placeholder: (provided:any) => ({
      ...provided,
      color: theme.colors.gray[500],
    }),
  };

  return <Select<Option, IsMulti, Group> styles={customStyles} {...props} />;
};
